import Icons from '../../Icons'
import { lightTheme } from '@/customTheme'
import ButtonCustom from '@/components/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import { KIND } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import { NavbarButtonBaseProps } from '../navbarConfig'
import { FloatingInspectorButtonSet } from '@/constants/app-options'

interface NavbarBackButtonProps extends NavbarButtonBaseProps {
  onClick?: () => void
  /**
   * Drives the back-button label for the few flows that use the navbar's
   * `customButtonSet` mode. Defaults to "AI models" so existing call sites
   * keep their previous behavior.
   */
  mode?: FloatingInspectorButtonSet
  /** Explicit label override; takes precedence over `mode`. */
  label?: string
}

function NavbarBackButton({ disabled, onClick, mode, label: labelOverride }: NavbarBackButtonProps) {
  const { t } = useTranslation()

  const iconAndTextColor = disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray
  const label = labelOverride ?? (mode === 'photoshoot' ? t('Photoshoot') : t('AI models'))

  return (
    <ButtonCustom
      type={SizeButton.STANDARD}
      kind={KIND.tertiary}
      disabled={disabled}
      style={{
        width: 'fit-content',
        gap: '4px',
        padding: '8px 12px',
        border: 'none',
        borderRadius: '360px',
        background: 'transparent',
        ':hover': {
          border: 'none',
          background: disabled ? 'transparent' : lightTheme.colors.grayScale50,
        },
        ':active': {
          border: 'none',
          background: disabled ? 'transparent' : lightTheme.colors.grayScale100,
        },
      }}
      onClick={onClick}
    >
      <Icons.Back size={20} fill={iconAndTextColor} />
      <p
        style={{
          ...lightTheme.typography.Small14Semibold,
          color: iconAndTextColor,
          margin: 0,
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </p>
    </ButtonCustom>
  )
}

export default NavbarBackButton
